export default __webpack_public_path__ + "static/media/AR.fc40acf7.svg";